import { Category, Role } from "protos/robot_syncer/plant_profile";
import {
  type CreateCategoryTemplateArgs,
  useCreateCategoryTemplate,
} from "portal/components/categoryTemplates/createCategory/useCreateCategoryTemplate";
import { useCallback, useState } from "react";

export type PendingCopyCategoryToLibrary = {
  category: Category;
  role: Role;
};

export type UseCopyCategoryToLibraryResult = {
  pending?: PendingCopyCategoryToLibrary;
  requestCopy: (category: Category, role: Role) => void;
  closeAlmanacDialog: () => void;
  createCategoryTemplate: (
    args: CreateCategoryTemplateArgs
  ) => Promise<string | undefined>;
};

export const useCopyCategoryToLibrary = (
  customerUuid?: string
): UseCopyCategoryToLibraryResult => {
  const createCategoryTemplate = useCreateCategoryTemplate(customerUuid);
  const [pending, setPending] = useState<
    PendingCopyCategoryToLibrary | undefined
  >();

  const requestCopy = useCallback((category: Category, role: Role): void => {
    setPending({ category, role });
  }, []);

  const closeAlmanacDialog = useCallback(() => {
    setPending(undefined);
  }, []);

  return {
    pending,
    requestCopy,
    closeAlmanacDialog,
    createCategoryTemplate,
  };
};
